<template>
  <v-card light>
    <v-img
      gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.2)"
      class="bg-sub white--text py-40-px"
    >
      <!-- <v-img src="/images/logo.png" contain height="40" /> -->
      <v-toolbar class="bg-transparent w-100-pct" absolute flat>
        <v-toolbar-title></v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn v-if="loginUser.flag !== 2" icon dark @click="close()">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-btn v-if="loginUser.flag === 2" icon dark  @click="ChangeDialog('Logout')">
          <v-icon>mdi-logout</v-icon>
        </v-btn>
      </v-toolbar>
    </v-img>

    <v-card-text class="white pb-6-px pt-16-px">
      <v-form @keyup.native.enter="submit()">
        <v-text-field
          v-model="payload.newPwd"
          class="mt-10-px"
          :placeholder="$t('PASSWORD_NEW')"
          hide-details
          outlined
          required
          :append-icon="showPasswordNew ? 'mdi-eye' : 'mdi-eye-off'"
          :type="showPasswordNew ? 'text' : 'password'"
          @click:append="showPasswordNew = !showPasswordNew"
        ></v-text-field>

        <v-text-field
          v-model="payload.newPwdCheck"
          class="mt-10-px"
          :placeholder="$t('PASSWORD_NEW_CHECK')"
          hide-details
          outlined
          required
          :append-icon="showPasswordNewCheck ? 'mdi-eye' : 'mdi-eye-off'"
          :type="showPasswordNewCheck ? 'text' : 'password'"
          @click:append="showPasswordNewCheck = !showPasswordNewCheck"
        ></v-text-field>

        <v-divider class="my-15-px"></v-divider>

        <v-text-field
          v-model="payload.oriPwd"
          :placeholder="$t('PASSWORD_OLD')"
          hide-details
          outlined
          required
          :append-icon="showPasswordOld ? 'mdi-eye' : 'mdi-eye-off'"
          :type="showPasswordOld ? 'text' : 'password'"
          @click:append="showPasswordOld = !showPasswordOld"
        ></v-text-field>
        <v-alert v-if="alertMsg" class="mt-8-px" dense text type="error">
          {{ $t(alertMsg) }}
        </v-alert>

        <v-btn block dark large class="bg-main mt-10-px" @click="submit()"
          >submit</v-btn
        >
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
export default {
  name: 'SetPassword',

  data() {
    return {
      payload: {
        newPwd: '',
        newPwdCheck: '',
        oriPwd: ''
      },
      alertMsg: '',
      showPasswordNew: false,
      showPasswordNewCheck: false,
      showPasswordOld: false
    }
  },

  computed: {
    ...mapState('auth', ['isLogin', 'loginUser'])
  },

  methods: {
    ...mapMutations('common', ['ChangeDialog']),
    ...mapActions('auth', ['setAuth']),
    ...mapActions('message', ['setSnackbar']),
    submit() {
      const { newPwd, newPwdCheck, oriPwd } = this.payload
      const { loginname } = this.loginUser
      this.alertMsg = ''

      if (newPwd !== newPwdCheck) {
        this.alertMsg = 'PASSWORD_NEW_ERROR_1'
        return
      } else if (!oriPwd) {
        this.alertMsg = 'PASSWORD_NEW_ERROR_2'
        return
      }
      const data = {
        newPwd,
        oriPwd,
        loginname
      }
      this.$api.common.user.setPwd(data).then((res) => {
        this.setSnackbar({
          show: true,
          text: 'PASSWORD_NEW_SUCCESS',
          timeout: '4000'
        })
        this.ChangeDialog('')

        setTimeout(() => this.setAuth({ token: '', isLogin: false }), 2000)
      })
    },
    close() {
      this.ChangeDialog('')
      this.$router.push({
        path: '/'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
